<iot-platform-ui-simple-card [cssClasses]="cssClasses()" [element]="element()" [icon]="icon()" [withMenu]="withMenu()" class="card">
  <div cardContent fxLayout="column">
    <h3 class="card__title">{{ $safeNavigationMigration(element()?.label) | translate | infoDisplay }}</h3>
    <div class="threshold-card__form" fxLayout="row" fxLayoutAlign="start center">
      <mat-form-field color="accent" fxFlex>
        <mat-label>{{ $safeNavigationMigration(element()?.placeholder) | translate }}</mat-label>
        <mat-select
          (selectionChange)="onSelectionChange($safeNavigationMigration($event?.value))"
          [formControl]="control"
          [placeholder]=""
          [required]="$safeNavigationMigration(element()?.required)"
        >
          @for (threshold of thresholdDefinitions[element()?.type]; track threshold) {
            <mat-option [value]="threshold">{{ threshold.displayValue }}</mat-option>
          }
        </mat-select>
        @if (control?.errors?.required) {
          <mat-error>{{ 'SITES.CONFIGURATIONS.CARD.REQUIRED_ERROR_MESSAGE' | translate }}</mat-error>
        }
      </mat-form-field>
    </div>
  </div>
</iot-platform-ui-simple-card>
